<template>
    <div class="preview-table" :class="{ 'sticky-top': is_sticky }" ref="stickyDiv">
        <div v-for="index in depth" :key="index" :class="singleCard ? 'preview-table-inner' : 'card table-card mb-2'">
            <div :class="[singleCard ? 'px-0' : 'card-body px-0', { 'py-0': depth != index }]">
                <div class="row" v-if="depth == index" :class="{ 'mt-3': index >= 2 }">
                    <div class="col mb-3" :class="singleCard ? 'mx-0' : 'mx-3'">
                        <label class="form-label">{{ singleCard ? 'Select a Column' : 'Column to Preview' }}</label>
                        <accordion-select v-model="preview_table_val[index-1]" :options="source_columns"
                        placeholder="Select a Column"
                        @update:modelValue="updatePreviewTable(preview_table_val[index-1])"></accordion-select>
                    </div>
                </div>
                <p v-if="preview_table_val[index-1] != null && depth == 1" :class="singleCard ? 'mx-0' : 'mx-3'">The table below represents the number of records for each of the top 10 values for the given column. Drill deeper into the data or view a preview using the icons below.</p>
                <div class="table-width-responsive overflow-auto" style="max-height: 300px;" :class="{ 'table-card': singleCard }">
                    <table class="table table-without-pagination gy-0 m-0 bg-white" :class="{ 'preview-table-top': depth === 2 && index === 1 }" v-if="preview_table_val[index-1] != null">
                        <thead>
                            <tr>
                                <th class='ps-3 py-2'>{{ propercase(mirrorAccordionSelectStyle(preview_table_val[index-1].value)) }}</th>
                                <th class="py-2 ps-2">Records</th>
                                <th class="py-2" style="width:70px;">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="preview_table[index-1] == null">
                                <td colspan="3" class="text-center p-2"><div class="d-inline-block spinner-border spinner-border-sm ms-2" role="status"></div> Loading</td></tr>
                            <tr v-else-if="preview_table[index-1].length == 0">
                                <td colspan="3" class="text-center p-2"><strong><em>No records were found for the given column.</em></strong></td></tr>

                            <tr v-for="(f, row_num) in filteredRows(preview_table[index-1], index)" :key="f.name">
                                <td class='ps-3 align-middle ' v-if="f.name != null">
                                    {{f.name}}
                                </td>
                                <td class='ps-3 align-middle ' v-else>
                                    <em>null</em>
                                </td>
                                <td class="align-middle ps-2">{{ number_with_zero(f.count) }}</td>
                                <td class="text-nowrap" >
                
                                    <button type="button" class="btn btn-sm btn-none p-2 me-1" v-if="depth == index" @click="previewRecords(f.name)">
                                        <i class="fa fa-eye" v-if="preview_detail_loading != f.name" data-bs-toggle="tooltip" data-placement="top"  title="Preview" ></i>
                                        <div class="spinner-border spinner-border-sm" role="status" v-else></div>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-none p-2" v-if="depth == 1" @click="drilldown(row_num, f.name)">
                                        <i class="fas fa-arrow-down" data-bs-toggle="tooltip" data-placement="top"  title="Drill Down" ></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-none p-2" v-if="depth == 2 && index == 1" @click="removeDrilldown()">
                                        <i class="fas fa-close" data-bs-toggle="tooltip" data-placement="top"  title="Remove Drill Down"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="modal fade modal column-mapping-preview-modal" id="pathway-column-mapping-preview-modal" aria-labelledby="pathway-column-mapping-preview-modal" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content bg-white" v-if="preview_detail_table.length > 0">
                    <div class="modal-header">
                        <div class="d-flex align-items-start w-100">
                            <h5 class="modal-title mb-0">Preview</h5>
                            <div class="d-flex align-items-center">
                                <button type="button" class="btn btn-white close-modal" data-bs-dismiss="modal" @click="preview_detail_index=0" data-bs-toggle="tooltip" title="Close">
                                    <img class="icon" src="/img/icons/avid-icons/close.svg" alt="">
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body pt-0">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <div class="fw-semibold">Sample {{ preview_detail_index + 1 }} of {{ preview_detail_table.length }}</div>
                            <div class="d-flex align-items-center gap-2">
                                <button class="btn btn-secondary btn-icon-only-sm" :disabled="preview_detail_index === 0" @click="preview_detail_index--">
                                    <i class="fas fa-chevron-left"></i>
                                </button>
                                <button class="btn btn-secondary btn-icon-only-sm" :disabled="preview_detail_index >= preview_detail_table.length - 1" @click="preview_detail_index++">
                                    <i class="fas fa-chevron-right"></i>
                                </button>
                            </div>
                        </div>
                        <div class="table-card table-width-responsive p-0 mb-3">
                            <table class="table table-without-pagination table-striped mb-0">
                                <thead>
                                    <tr>
                                    <th class="ps-3">Column Name</th>
                                    <th>Column Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="node in nestedDetailTree" :key="node.key">
                                        <!-- 1) Leaf at root -->
                                        <tr v-if="node.type === 'field'">
                                        <td class="ps-3">{{ prettyName(node.key) }}</td>
                                        <td>{{ node.value }}</td>
                                        </tr>

                                        <!-- 2) First-level group header -->
                                        <tr
                                        v-else
                                        class="table-active"
                                        @click="toggleGroup(node.key)"
                                        style="cursor: pointer"
                                        >
                                        <td class="ps-3 align-middle">
                                            <div class="d-flex align-items-center">
                                                <button class="btn btn-secondary btn-icon-only-sm me-2">
                                                    <i
                                                    :class="openGroups[node.key]
                                                        ? 'fa fa-chevron-down'
                                                        : 'fa fa-chevron-right'"
                                                    ></i>
                                                </button>
                                                <span>{{ prettyName(node.key) }}</span>
                                                <small v-if="node.isArray" class="ms-1">({{ node.arrayCount }} items)</small>
                                            </div>
                                        </td>
                                        <td class="align-middle">
                                            <small class="btn-link">
                                            click to {{ openGroups[node.key] ? 'collapse' : 'expand' }}
                                            </small>
                                        </td>
                                        </tr>

                                        <!-- 3) Second-level (children of node) -->
                                        <template
                                        v-if="node.type === 'group' && openGroups[node.key]"
                                        v-for="child in node.children"
                                        :key="node.key + '-' + child.key"
                                        >
                                        <!-- 3a) Child is a field -->
                                        <tr v-if="child.type === 'field'">
                                            <td class="ps-5">{{ prettyName(child.key) }}</td>
                                            <td>{{ child.value }}</td>
                                        </tr>

                                        <!-- 3b) Child is its own group header -->
                                        <tr
                                            v-else
                                            class="table-active"
                                            @click="toggleGroup(child.key)"
                                            style="cursor: pointer"
                                        >
                                            <td class="ps-5 align-middle">
                                                <div class="d-flex align-items-center">
                                                    <button class="btn btn-secondary btn-icon-only-sm me-2">
                                                        <i
                                                        :class="openGroups[child.key]
                                                        ? 'fa fa-chevron-down'
                                                        : 'fa fa-chevron-right'"
                                                        ></i>
                                                    </button>
                                                    <span>{{ prettyName(child.key) }}</span>
                                                    <small v-if="child.isArray" class="ms-1">({{ child.arrayCount }} items)</small>
                                                </div>
                                            </td>
                                            <td class="align-middle">
                                            <small class="btn-link">
                                                click to {{ openGroups[child.key] ? 'collapse' : 'expand' }}
                                            </small>
                                            </td>
                                        </tr>

                                        <!-- 4) Grand-children (fields under that child) -->
                                        <tr
                                            v-if="child.type === 'group' && openGroups[child.key]"
                                            v-for="leaf in child.children"
                                            :key="child.key + '-' + leaf.key"
                                        >
                                            <td class="ps-5">{{ prettyName(leaf.key) }}</td>
                                            <td>{{ leaf.value }}</td>
                                        </tr>
                                        </template>
                                    </template>
                                    </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer pt-1">
                        <button type="button" class="btn btn-white" data-bs-dismiss="modal" v-on:click="preview_detail_index=0" >Close</button>
                    </div>
                </div>
                <div class="modal-content bg-white" v-else>
                    <div class="modal-header">
                        <div class="d-flex align-items-start w-100">
                            <h5 class="modal-title mb-0">Preview</h5>
                            <div class="d-flex align-items-center">
                                <button type="button" class="btn btn-white close-modal" data-bs-dismiss="modal" @click="preview_detail_index=0" data-bs-toggle="tooltip" title="Close">
                                    <img class="icon" src="/img/icons/avid-icons/close.svg" alt="">
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <h3>No records were found for the given column.</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import Swal from 'sweetalert2';

export default {
        props: {
            client: {
              type: Object,
            },
            source: {type: Object },
            source_columns: {
                default: () => []
            },
            data_type: {
                type: String,
                default: null
            },
            /** When true, render only inner content (no card wrapper, no "Column to Preview" label) for use inside a parent card. */
            singleCard: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                //data preview
                is_sticky: false,
                //data preview
                depth: 1,
                drill_index: null,
                preview_table_val: [],
                preview_table_logic: [],
                preview_table: [],
                preview_table_data_type: [], // Add this line to store data_type for each preview level
                preview_detail_table: [],
                preview_detail_index: 0,
                preview_detail_loading: "",
                row_num: 0,
                openGroups: {},
                src_column_array: null,
                preview_column_array: null, // preview_column_array is basically src_column_array without custom logic option at the end
            };
        },
        created () {
            window.addEventListener('scroll', this.handleScroll);
        },
        unmounted () {
            window.removeEventListener('scroll', this.handleScroll);
        },
        mounted() {
            //Ensure the tooltips show up
            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));

            for (var i = 0; i < tooltipTriggerList.length; i++) {
              (function(index) {
                tooltipTriggerList[index].addEventListener('click', function() {
                  // Hide the tooltip using the index passed to the closure
                  tooltipList[index].hide();
                });
                tooltipTriggerList[index].addEventListener('mouseleave', function() {
                  // Hide the tooltip using the index passed to the closure
                  tooltipList[index].hide();
                });
              })(i);
            }

        },
        watch: {
            // Watch for changes in the computed property to trigger the re-render of the component.
            local_census_connection: {
              handler(n, o) {
                this.setupUI();
              },
              deep: true,
            },
        },
        computed: {
            nestedDetailTree() {
                const row = this.preview_detail_table[this.preview_detail_index] || {};
                // root will hold children keyed by name/index
                const root = {};

                // for each flat key/value, insert into the tree
                Object.entries(row).forEach(([flatKey, value]) => {
                if (flatKey.startsWith('_') ||  flatKey.indexOf('._') !== -1 || value == null) return;

                const parts = flatKey.split('.'); 
                // e.g. ["contacts","0","emails","0","email"]

                let cursor = root;
                // iterate through all but the last segment
                for (let i = 0; i < parts.length - 1; i++) {
                    const part = parts[i];
                    // skip purely-numeric keys—they’re array indexes
                    if (!isNaN(part)) continue;

                    // ensure a node for this part
                    cursor[part] = cursor[part] || { __children: {}, __isArray: false };
                    // if next segment is numeric, mark as array
                    if (!isNaN(parts[i + 1])) {
                    cursor[part].__isArray = true;
                    }
                    // descend into its children
                    cursor = cursor[part].__children;
                }

                // now at the parent of the leaf
                const leafKey = parts[parts.length - 1];
                cursor[leafKey] = cursor[leafKey] || { __children: null };
                // store the leaf’s value
                cursor[leafKey].__value = value;
                });

                // convert the tree object into an ordered array of nodes
                const makeList = (obj) => {
                return Object.entries(obj)
                    .map(([key, node]) => {
                    // Ensure node has the expected structure
                    if (!node || typeof node !== 'object') {
                        return null;
                    }
                    
                    if (node.__children) {
                        // Calculate array count for arrays
                        let arrayCount = null;
                        if (node.__isArray) {
                            // For arrays, we need to count the actual array elements
                            // Look at the original data to find all keys that belong to this array
                            const childKeys = Object.keys(node.__children);
                            
                            // Count how many unique array indices exist
                            // This gives us the actual array size
                            arrayCount = childKeys.length;
                        }
                        
                        return {
                        type: 'group',
                        key,
                        isArray: node.__isArray,
                        arrayCount: arrayCount,
                        children: makeList(node.__children)
                        };
                    } else if (node.__value !== undefined) {
                        return {
                        type: 'field',
                        key,
                        value: node.__value
                        };
                    } else {
                        // Handle cases where node doesn't have expected structure
                        return {
                        type: 'field',
                        key,
                        value: node
                        };
                    }
                    })
                    .filter(item => item !== null) // Remove null items
                    // **PRUNE EMPTY GROUPS**
                    .filter(item =>
                    item.type === 'field' ||
                    (item.type === 'group' && item.children.length > 0)
                    );
                };

                return makeList(root);
            }
        },
        methods: {
            toggleGroup(g) {
                this.openGroups[g] = !this.openGroups[g]
            },
            prettyName(str) {
                // reuse your getPrettyColName logic here
                return this.getPrettyColName(str)
            },
            updatePreviewTable(column_obj) {
                this.preview_table[this.depth-1] = null;
                this.preview_table_logic[this.depth-1] = null;

                if(column_obj == null || column_obj.value == "") {
                    this.preview_table_val[this.depth-1] = null
                    this.preview_table_logic[this.depth-1] = null;
                    return;
                }

                // Store the data_type for the current depth level
                // Try to determine data_type from the column_obj or use the prop as fallback
                let data_type = 'string'; // default fallback
                if (this.data_type) {
                    data_type = this.data_type;
                } else if (column_obj.data_type) {
                    data_type = column_obj.data_type;
                }
                this.preview_table_data_type[this.depth-1] = data_type;

                this.getPreviewTableData(column_obj.value);
            },
            getPreviewTableData(column, column_logic = null) {
                //Hide the preview tool tips
                let tips = document.getElementsByClassName('tooltip');
                for (var i = 0; i < tips.length; i++)
                //Remove the show class from ti
                    tips[i].classList.remove('show');

                var data = {
                    client: this.client,
                    source: this.source.data_source.data_source,
                    column: column,
                    logic: null,
                    limit: 10,
                    data_source_id: this.source.data_source.id,
                    data_type: this.preview_table_data_type[this.depth-1] || this.data_type || 'string', // Use stored data_type, prop, or default to string
                    // value: this.dataset.filter
                };

                //I need to add the filter for the first level if I'm two down.
                if(this.depth == 2) {
                    data.filter = [{
                        column: this.preview_table_val[0].value,
                        value: this.preview_table[0][this.drill_index].name
                    }];
                }

                var self = this;

                window.axios.post('/api/bigquery/get_samples', data)
                .then(response => {
                    self.preview_table[self.depth-1] = response.data.samples;
                    self.$forceUpdate();
                })
                .catch(error => {
                    // Handle errors here
                    if (error.response.status == 400 && error.response.data.error_type == 'missing_column') {
                        // For this component, we just clear the preview table values
                        self.preview_table_val = [];

                        Swal.fire({
                            title: "The selected column has been removed",
                            text: "The database column was removed from the source data. We've updated this data set to reflect that recent change.",
                            icon: "success",
                            showCancelButton: false,
                            confirmButtonText: "OK",
                            customClass: {
                                popup: 'swal-success'
                            },
                        })

                        self.$forceUpdate();
                    }
                    else if (error.response.status == 400 && error.response.data.error_type == 'sql_error') {
                        Swal.fire({
                            title: "There is an error with your custom logic",
                            html: error.response.data.message,
                            icon: "error",
                            showCancelButton: false,
                            confirmButtonText: "OK",
                            customClass: {
                                popup: 'swal-error'
                            },
                        })
                    }
                });
            },
            mirrorAccordionSelectStyle(value) {
                //If it contains a ., then replace it with a : and a space and then propercase all the words
                let val = value.value;
                if(val && val.indexOf(".") != -1) {
                    var split = val.split(".", 2);
                    return this.propercase(split[0].trim()) + ": " + this.propercase(split[1].trim());
                }
                return val;
            },
            previewRecords(column_value) {
                var self = this;
                var data = {
                    data_source: this.source.data_source.data_source,
                    filter:  [{
                        column: typeof this.preview_table_val[this.depth-1] == 'object' ? this.preview_table_val[this.depth-1].value : this.preview_table_val[this.depth-1],
                        value: column_value
                    }],
                    limit: 10,
                    data_source_id: this.source.data_source.id,
                    client_id: this.client.id,
                    data_type: this.preview_table_data_type[this.depth-1] || this.data_type || 'string' // Use stored data_type, prop, or default to string
                };

                //I need to add the filter for the first level if I'm two down.
                if(this.depth == 2) {
                    data.filter.push({
                        column: this.preview_table_val[0].value,
                        value: this.preview_table[0][this.drill_index].name
                    });
                }

                this.preview_detail_loading = column_value;

                window.axios.post('/api/bigquery/get_detailed_samples', data).then(response => {
                    if(response.status == 200) {

                        self.preview_detail_table = response.data.samples;
                        self.preview_detail_loading = "";

                        var myModal = new bootstrap.Modal(document.getElementById('pathway-column-mapping-preview-modal'))
                        myModal.show()
                    }
                });
            },
            drilldown(index, column_value) {
                this.depth++;
                this.drill_index = index;
            },
            removeDrilldown() {
                this.drill_index = null;
                this.depth--;
                this.preview_table_val[1] = null;
                this.preview_table[1] = null;
                this.preview_table_data_type[1] = null; // Clear the data_type for the second level
            },
            getPrettyColNameByIndex(index) {
                var name = Object.keys(this.preview_detail_table[this.preview_detail_index])[index];
                return this.getPrettyColName(name);
            },
            getPrettyColName(name) {

                var cols = Object.keys(this.source_columns);
                for(var i = 0; i < cols.length; i++) {
                    if(cols[i] == name){
                        let value = Object.values(this.source_columns)[i].value;
                        if(value && value.indexOf(".") != -1) {
                            let split = value.split(".", 2);
                            return this.propercase(split[0].trim()) + ": " + this.propercase(split[1].trim());
                        }
                        return value;
                    }
                }

                return this.propercase(name);
            },

            handleScroll() {
                if(this.$refs.stickyDiv == null) return;

                const divTop = this.$refs.stickyDiv.getBoundingClientRect().top;
                this.is_sticky = divTop <= 0;
            },
            filteredRows(rows, index) {
                if (!rows) return [];
                
                // Filter out rows where column name starts with "_" or has array values
                let filtered = rows.filter(row => {
                    // Skip if column name starts with "_"
                    if (row.name && row.name.toString().startsWith('_')) {
                        return false;
                    }
                    // Skip if value is an array
                    if (Array.isArray(row.name)) {
                        return false;
                    }
                    return true;
                });
                
                if (index === 1 && this.drill_index !== null) {
                    return [filtered[this.drill_index]];
                }
                return filtered;
            },
            getFilteredDetailColumns(detailRow) {
                if (!detailRow) return [];
                
                const entries = Object.entries(detailRow);
                const filtered = entries.filter(([key, value]) => {
                    // Skip if column name starts with "_"
                    if (key && (key.toString().startsWith('_') || key.toString().indexOf('__') !== -1)) {
                        return false;
                    }
                    // Skip if value is an array
                    if (Array.isArray(value) || value == null) {
                        return false;
                    }
                    return true;
                });
                
                return filtered.map(([key, value], index) => ({ key, value, index }));
            }, 
        }
    }
</script>